import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { tenderEventComponent } from './tenderEvent.component';
import { DossierDetailModule } from '../components/dossierDetail.module';
import { dossierBasicInfoComponent } from '../components/dossierBasicInfo.component';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TranslateModule } from '@ngx-translate/core';
import { MainPipes } from '../../pipes/main-pipes-module';
import { DossierHeaderModule } from '../components/dossierHeader.module';
import { tenderViewComponent } from '../tenderView/tenderView.component';
import { tenderEventProcessComponent } from './tenderEventProcess.component';
import { decipherProcessComponent } from './decipherProcess.component';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { FilePDFViewerModule } from '../../documents/filePDFViewer/filePDFViewer.module';
import { documentFileViewerComponent } from '../../documents/documentFileViewer/documentFileViewer.component';
import { TableModule } from 'primeng-lts/table';
import { EnvelopeStatusTableComponent } from '../tenderView/envelopeStatusTable.component';
import { TenderViewModule } from '../tenderView/tenderView.module';
import { DirectivesModule } from '../../directives/directives.module';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { ConfirmationService } from 'primeng-lts/api';
import { ButtonModule } from 'primeng-lts/button';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { MenuModule } from 'primeng-lts/menu';
import { PanelModule } from 'primeng-lts/panel';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TooltipModule } from 'primeng-lts/tooltip';
import { BlockUIModule } from 'primeng-lts/blockui';
import { ProgressBarModule } from 'primeng-lts/progressbar';

@NgModule({
  declarations: [
    tenderEventComponent,
    tenderEventProcessComponent,
    decipherProcessComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    DossierHeaderModule,
    DossierDetailModule,

    TableModule,
    TooltipModule,
    FormPlycaModule,
    FilePDFViewerModule,
    PanelModule,
    BlockUIModule,
    MenuModule,
    ButtonModule,
    DropdownModule,
    TranslateModule,
    MainPipes,
    WaitLoadingModule,
    ProgressBarModule,
    ConfirmDialogModule,
    TenderViewModule,
    DirectivesModule,
    ScrollPanelModule,
    SubHeaderModule
  ],
  providers: [ConfirmationService],
  entryComponents: [
    tenderEventProcessComponent,
    decipherProcessComponent,
    dossierBasicInfoComponent,
    tenderViewComponent,
    documentFileViewerComponent,
    EnvelopeStatusTableComponent
  ]
})
export class TenderEventModule { }
